export function SeparatorLine() {
	return (
		<hr
			style={{
				border: 0,
				height: "1px",
				backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1.5), rgba(0, 0, 0, 0))",
			}}
		></hr>
	);
}
